import { render, staticRenderFns } from "./getLoation.vue?vue&type=template&id=800aa44c&"
import script from "./getLoation.vue?vue&type=script&lang=js&"
export * from "./getLoation.vue?vue&type=script&lang=js&"
import style0 from "./getLoation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports